<template>
    <transition name="el-fade-in-linear">
        <div v-show="showMain" class="transition-box">
            <div id="formblock">
                <SearchBar ref="searchRef" msg="B110" @search="onLoadTable" />
            </div>
            <div id="datablock" style="height: calc(100vh - 352px)">
                <el-row type="flex" justify="end">
                    <el-button type="primary" round plain @click="onExportClick" v-show="store.getters.check_auth('PRINT')">下載訂單明細費用</el-button>
                </el-row>
                <div ref="table" style="margin-top:10px;"></div>
            </div>
        </div>
    </transition>
</template>

<script setup>
    import { ref, reactive, onBeforeMount, onMounted, nextTick } from 'vue';
    import { TabulatorFull as Tabulator } from 'tabulator-tables'; //import Tabulator library
    import { ElMessage, ElMessageBox } from 'element-plus'
    import { useDownload } from '@/composables/download'
    import SearchBar from '@/components/SearchBar.vue'
    import $api from '@/utils/axios';
    import { useStore } from "vuex";
    const store = useStore();

    const showMain = ref(true);//顯示主頁面

    const searchRef = ref(null);

    const table = ref(null); //reference to your table element
    const tabulator = ref(null); //variable to hold your table

    const onLoadTable = (data) => {
        console.log(data);
        $api.GET('/api/DtBill/GetLogisticsTableData', data
        ).then((response) => {
            tabulator.value.setData(response);
        });
    }

    const onExportClick = () => {
        $api.POST('/api/DtBill/ExportExcel', searchRef.value.searchForm).then((response) => {
            useDownload('/api/Home/DownloadFile?URL_ADDR=' + response, response.split('\\')[1]);
        });
    }

    onMounted(() => {
        //instantiate Tabulator when element is mounted
        tabulator.value = new Tabulator(table.value, {
            locale: "zh-tw",
            layout: "fitColumns",      //fit columns to width of table
            maxHeight: "calc(100vh - 392px)", //do not let table get bigger than the height of its parent element
            columnHeaderVertAlign: "middle", //align header contents to middle of cell
            pagination: true,       //paginate the data
            paginationSize: 50,         //allow 50 rows per page of data
            paginationSizeSelector: [50, 100, 200],
            columns: [
                { title: "No", formatter: "rownum", width: 50, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "出貨門市名稱", field: "DEPT_COMP_NAME",width: 130, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "付款對象", field: "PAY_OUTLET", width: 90, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "訂單日期", field: "DEPT_TIME", width: 90, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { 
                    title: "訂單金額", field: "PRODUCT_AMT", width: 80, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // Format #,##0
                        let val = cell.getValue();
                        if (val == 0 || val == null) {
                            return "";
                        } else {
                            return val.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
                { title: "商家訂單號", field: "WORK_NO",width: 180, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "客戶名稱", field: "DEST_COMP_NAME",width: 90, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "託運單號", field: "DLV_NO",width: 150, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "狀態", field: "LAST_STATUS_DESC",width: 90, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { 
                    title: "距離/KM", field: "CHARGE_DLV_KM", width: 90, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // Format #,##0.000
                        let val = cell.getValue();
                        if (val == 0 || val == null) {
                            return "";
                        } else {
                            return val.toFixed(3).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
                { 
                    title: "外送費", field: "CHARGE_AMT", width: 70, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // Format #,##0
                        let val = cell.getValue();
                        if (val == 0 || val == null) {
                            return "";
                        } else {
                            return val.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
                { 
                    title: "加派費", field: "ADD_DLV_AMT", width: 70, headerHozAlign: "center", hozAlign: "right", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // Format #,##0
                        let val = cell.getValue();
                        if (val == 0 || val == null) {
                            return "";
                        } else {
                            return val.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
                { 
                    title: "返送費", field: "RETURN_AMT", width: 70, headerHozAlign: "center", hozAlign: "right", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // Format #,##0
                        let val = cell.getValue();
                        if (val == 0 || val == null) {
                            return "";
                        } else {
                            return val.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
                {
                    title: "代收貨款", field: "COLLECT_AMT", width: 70, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // Format #,##0
                        let val = cell.getValue();
                        if (val == 0 || val == null) {
                            return "";
                        } else {
                            return val.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
                { 
                    title: "手續費", field: "HANDLE_AMT", width: 70, headerHozAlign: "center", hozAlign: "right", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // Format #,##0
                        let val = cell.getValue();
                        if (val == 0 || val == null) {
                            return "";
                        } else {
                            return val.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
            ],
            langs: {
                "zh-tw": {
                    "pagination": {
                        "page_size": "選擇筆數",
                        "first": "第一頁",
                        "last": "最後一頁",
                        "prev": "上一頁",
                        "next": "下一頁",
                    }
                }
            },
        });
    });

</script>
